import CommonState from './CommonState'
import lang from '@/lang'

export const ALL = new CommonState(null, '全部', 'All')

// --------------
// 合同类型
// --------------
export const FIRST_SIGN = new CommonState('FIRST', '首签', 'First Sign')
export const RENEW_CONTRACT = new CommonState('RENEW', '续签', 'Renew Contract')

/**
 *
 * 合同类型:<br>
 * ["FIRST","首签","First Sign"]<br>
 * ["RENEW","续签","Renew Contract"]
 */
export const CONTRACT_TYPE = ([
  FIRST_SIGN,
  RENEW_CONTRACT
])

export const CONTRACT_TYPE_SEARCH = ([
  ALL,
  FIRST_SIGN,
  RENEW_CONTRACT
])

// --------------
// 合同审核状态
// --------------
export const REVIEW_STAGE_DRAFT = new CommonState(0, '待审核', 'draft')
export const REVIEW_STAGE_APPROVE = new CommonState(1, '审核通过', 'approved')
export const UNDER_REVIEW = new CommonState(2, '审核中', 'Under Audit')

/**
 *
 * 合同类型:<br>
 * ["FIRST","首签","First Sign"]<br>
 * ["RENEW","续签","Renew Contract"]
 */
export const STATE = ([
  REVIEW_STAGE_DRAFT,
  REVIEW_STAGE_APPROVE,
  UNDER_REVIEW
])

export const STATE_SEARCH = ([
  ALL,
  REVIEW_STAGE_DRAFT,
  REVIEW_STAGE_APPROVE,
  UNDER_REVIEW
])

// --------------
// 合同状态
// --------------
export const STAGE_EXPIRED = new CommonState(1, '已到期', 'Expired')
export const STAGE_WILLEXPIRED = new CommonState(2, '临期', 'WillExpired')
export const STAGE_UNEXPIRED = new CommonState(3, '未到期', 'UnExpired')
export const STAGE_RENEW = new CommonState(4, '已续签', 'Renew')
export const STAGE_TERMINATE = new CommonState(5, '终止合作', 'Terminate')
export const STAGE_HISTORY = new CommonState(9, '历史', 'History')
export const STAGE_POSTPONED = new CommonState(6, '已延期', 'Postponed')

export const STAGE_UNEXPIRED_AND_POSTPONED = new CommonState(3, '未到期/延期', 'UnExpired/Postponed')

/**
 * 合同状态<br>
 * 1,"已到期","Expired"<br>
 * 2,"临期","WillExpired"<br>
 * 3,"未到期","UnExpired"<br>
 * 4,"已续签","Renew"<br>
 * 5,"终止合同","Terminate"<br>
 * 9,"历史","History"
 */
export const CONTRACT_STATUS = ([
  STAGE_EXPIRED,
  STAGE_WILLEXPIRED,
  STAGE_UNEXPIRED,
  STAGE_RENEW,
  STAGE_TERMINATE,
  STAGE_HISTORY,
  STAGE_POSTPONED
])

export const CONTRACT_STATUS_SEARCH = ([
  ALL,
  STAGE_EXPIRED,
  STAGE_UNEXPIRED,
  STAGE_RENEW,
  STAGE_TERMINATE
])

// --------------
// 合同协议
// --------------
export const CONTRACTAGREEMENT_NONE = new CommonState(0, '无协议', 'none')
export const CONTRACTAGREEMENT_CUSTOMER = new CommonState(1, '客户合同', 'Customer')
export const CONTRACTAGREEMENT_SUPPLIER = new CommonState(2, '供应商合同', 'Supplier')
export const CONTRACTAGREEMENT_OVERSEAAGENT = new CommonState(3, '海外代理合同', 'Oversea Agent')
export const CONTRACTAGREEMENT_OTHER = new CommonState(9, '其他合同', 'Other')

export const CONTRACTAGREEMENT_TYPE = ([
  CONTRACTAGREEMENT_CUSTOMER,
  CONTRACTAGREEMENT_SUPPLIER,
  CONTRACTAGREEMENT_OVERSEAAGENT,
  CONTRACTAGREEMENT_OTHER
])

export const CONTRACTAGREEMENT_TYPE_SEARCH = ([
  ALL,
  CONTRACTAGREEMENT_CUSTOMER,
  CONTRACTAGREEMENT_SUPPLIER,
  CONTRACTAGREEMENT_OVERSEAAGENT,
  CONTRACTAGREEMENT_OTHER
])

// --------------
// 结算方式
// --------------
export const CREDITDATETYPE_MONTH = new CommonState(-1, '按月结算', 'Month')
export const CREDITDATETYPE_MONTH2 = new CommonState(0, '按月结算', 'Month')
export const CREDITDATETYPE_WEEK = new CommonState(-2, '按周结算', 'Week')
export const CREDITDATETYPE_DAY = new CommonState(1, '每月指定日期', 'Day')
export const CREDITDATETYPE_HALFMONTH = new CommonState(-3, '半月结', 'HalfMonth')
export const CREDITDATETYPE_DAY2 = new CommonState(-4, '按天结算', 'Day')

export const CREDITDATETYPE_TYPE = ([
  CREDITDATETYPE_MONTH,
  CREDITDATETYPE_MONTH2,
  CREDITDATETYPE_WEEK,
  CREDITDATETYPE_HALFMONTH,
  CREDITDATETYPE_DAY2
])

export const CREDITDATETYPE_TYPE_SEARCH = ([
  ALL,
  CREDITDATETYPE_MONTH,
  CREDITDATETYPE_WEEK,
  CREDITDATETYPE_DAY,
  CREDITDATETYPE_HALFMONTH
])

// --------------
// 日期类型
// --------------
export const DATETYPE_ETD = new CommonState('ETD', 'ETD', 'ETD')
export const DATETYPE_ETA = new CommonState('ETA', 'ETA', 'ETA')
export const DATETYPE_ATD = new CommonState('ATD', 'ATD', 'ATD')
export const DATETYPE_ATA = new CommonState('ATA', 'ATA', 'ATA')
export const DATETYPE_BUSINESSDATE = new CommonState('businessDate', '业务日期', 'BusinessDate')
export const DATETYPE_INVOICEDATE = new CommonState('invoiceDate', '发票日期', 'InvoiceDate')
export const DATETYPE_BILLINGDATE = new CommonState('billingDate', '账单日期', 'BillingDate')
export const DATETYPE_ACCOUNTINGDATE = new CommonState('accountingDate', '费用财务日期', 'AccountingDate')
export const DATETYPE_DELIVERY_COMPLETION_DATE = new CommonState('deliveryCompletionDate', '实际送货日期', 'Actual delivery date')
export const DATETYPE_OVERSEA_INVOICE_DATE = new CommonState('overseaInvoiceDate', '国外发票开票时间', 'Oversea invoice date')

export const DATETYPE_TYPE = ([
  DATETYPE_ETD,
  DATETYPE_ETA,
  DATETYPE_ATD,
  DATETYPE_ATA,
  DATETYPE_BUSINESSDATE,
  DATETYPE_INVOICEDATE,
  DATETYPE_BILLINGDATE,
  DATETYPE_ACCOUNTINGDATE,
  DATETYPE_DELIVERY_COMPLETION_DATE,
  DATETYPE_OVERSEA_INVOICE_DATE
])

export const DATETYPE_TYPE_SEARCH = ([
  ALL,
  DATETYPE_ETD,
  DATETYPE_ETA,
  DATETYPE_ATD,
  DATETYPE_ATA,
  DATETYPE_BUSINESSDATE,
  DATETYPE_INVOICEDATE,
  DATETYPE_BILLINGDATE,
  DATETYPE_ACCOUNTINGDATE,
  DATETYPE_DELIVERY_COMPLETION_DATE,
  DATETYPE_OVERSEA_INVOICE_DATE
])

// --------------
// 账期单位
// --------------
export const UNIT_DAY = new CommonState(0, '天', 'Day')
export const UNIT_WEEK = new CommonState(1, '周', 'Week')
export const UNIT_MONTH = new CommonState(2, '月', 'Month')

export const UNIT_TYPE = ([
  UNIT_DAY,
  UNIT_WEEK,
  UNIT_MONTH
])

export const UNIT_TYPE_SEARCH = ([
  ALL,
  UNIT_DAY,
  UNIT_WEEK,
  UNIT_MONTH
])

// --------------
// 额度币种
// --------------
export const CURRENCY_RMB = new CommonState('RMB', 'RMB', 'RMB')
export const CURRENCY_USD = new CommonState('USD', 'USD', 'USD')

export const CURRENCY_TYPE = ([
  CURRENCY_RMB,
  CURRENCY_USD
])

export const CURRENCY_TYPE_SEARCH = ([
  ALL,
  CURRENCY_RMB,
  CURRENCY_USD
])

// --------------
// 结算类型
// --------------
export const SETTLEMENTTYPE_JOB = new CommonState('JOB', '票结', 'Job')
export const SETTLEMENTTYPE_NOTJOB = new CommonState('NOTJOB', '非票结', 'NotJob')

export const SETTLEMENTTYPE_TYPE = ([
  SETTLEMENTTYPE_JOB,
  SETTLEMENTTYPE_NOTJOB
])

export const SETTLEMENTTYPE_TYPE_SEARCH = ([
  ALL,
  SETTLEMENTTYPE_JOB,
  SETTLEMENTTYPE_NOTJOB
])

// 合同修改日志类型
export const ADD_CONTRACT = new CommonState(1, lang.t('CargoMsg.Cargo_AddContract'), 'add')
export const EDIT_CONTRACT = new CommonState(2, lang.t('CargoMsg.Cargo_EditContract'), 'Edit')
export const RENEW_CONTRACT_LOG = new CommonState(3, lang.t('CargoMsg.Cargo_RenewContract'), 'Renew')
export const REPEAL_CONTRACT = new CommonState(4, '撤销合同', 'Repeal')
export const UPLOAD_CONTRACT_ATTACHMENTS = new CommonState(5, lang.t('CargoMsg.Cargo_UploadContractAttachments'), 'Upload')
export const ADD_CONTRACT_ATTACHMENTS = new CommonState(6, lang.t('CargoMsg.Cargo_UploadAttachment'), 'Upload')
export const DEL_CONTRACT_ATTACHMENTS = new CommonState(7, lang.t('CargoMsg.Cargo_DeleteAttachment'), 'Upload')

export const CONTRACT_LOG_TYPE = ([
  ADD_CONTRACT,
  EDIT_CONTRACT,
  RENEW_CONTRACT_LOG,
  REPEAL_CONTRACT,
  UPLOAD_CONTRACT_ATTACHMENTS,
  ADD_CONTRACT_ATTACHMENTS,
  DEL_CONTRACT_ATTACHMENTS
])

// 合同规则 默认值 【全部订单】
export const RULE_ALL_ORDERS = new CommonState('AllOrders', '全部订单', 'AllOrders')
